import React from 'react';
import { Link } from 'react-router-dom';
import collageImage from '../assets/prefooter-collage.png';

const PreFooterCTA = () => {
  return (
    <section className="bg-white">
      <div className="mx-3 md:mx-10 lg:mx-16 py-16 md:py-24">
        <div className="rounded-3xl bg-gray-50 border border-gray-100 px-6 md:px-10 lg:px-14 py-12 md:py-16 overflow-hidden">
          <div className="flex flex-col items-center text-center">
            <div className="w-full">
              <img
                src={collageImage}
                alt="Learning collage"
                className="w-full max-w-6xl mx-auto"
              />
            </div>

            <h2 className="text-4xl md:text-4xl font-inter font-medium text-acBlack leading-[1.05]">
              Begin Learning Today And
              <br />
              Grow Your Expertise
            </h2>

            <p className="mt-4 text-sm md:text-base text-acGray font-inter max-w-3xl">
              Explore curated business and tech courses. Learn on the platforms they are hosted on,
              with confidence in what you are buying.
            </p>

            <div className="mt-8">
              <Link
                to="/#courses"
                className="px-8 py-3.5 rounded-full bg-acBlack text-white text-sm md:text-base font-inter font-semibold hover:opacity-90 transition"
              >
                Browse Courses
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PreFooterCTA;
